<mat-card
  *ngIf="!datosContratanteVisible && !firmaVisible && !firmaDigitalState"
  style="margin-top: 2.4375rem"
>
  <mat-card-header>
    <mat-card-title>FIRMA ELECTRÓNICA</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="container">
      <p>
        Estimado cliente:
      </p>
      <p>
        Para habilitar los servicios en línea, debes firmar el
        <strong>Convenio de Prestación de Servicios a Distancia.</strong> Puedes
        hacerlo rápidamente y online a través del certificado de firma
        electrónica:
      </p>
      <div class="center-block">
        <app-mini-loader *ngIf="loading"></app-mini-loader>
        <button
          [disabled]="loading"
          mat-stroked-button
          (click)="goDatosContratante()"
        >
          <span>Firma Aquí</span>
        </button>
      </div>

      <p>
        O firmando personalmente el documento en una de nuestras sucursales.
      </p>
      <p>
        En caso de dudas, comunícate con nosotros a través del
        <strong>800 222 100.</strong>
      </p>
    </div>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="datosContratanteVisible">
  <mat-card-header>
    <mat-card-title>CONFIRME SUS DATOS</mat-card-title>
  </mat-card-header>
  <mat-card-content [ngSwitch]="editMode">
    <div class="container">
      <app-mini-loader *ngIf="loading"></app-mini-loader>
      <app-error *ngIf="error && !loading"></app-error>
      <div *ngIf="!loading && !error">
        <div>
          <p>Estimado cliente:</p>
          <p>
            Antes de continuar, verifica que esta información sea
            <strong><u>idéntica</u></strong> a tu Cédula de Identidad y
            actualiza tu correo si es necesario.
          </p>
        </div>
        <div *ngSwitchDefault class="conatiner-datos">
          <div class="row rut">
            <div><span>Rut</span></div>
            <div class="row-2">
              <span>{{ datoContratante?.RUT }}</span>
            </div>
          </div>
          <div class="row nombre">
            <div><span>Nombres</span></div>
            <div class="row-2">
              <span>{{ datoContratante?.NOMTER }}</span>
            </div>
          </div>
          <div class="row apellidoP">
            <div><span>Apellido Paterno</span></div>
            <div class="row-2">
              <span>{{ datoContratante?.APEPATER }}</span>
            </div>
          </div>

          <div class="row apellidoM">
            <div><span>Apellido Materno</span></div>
            <div class="row-2">
              <span>{{ datoContratante?.APEMATER }}</span>
            </div>
          </div>

          <div class="row correo">
            <span>Correo electrónico</span>
            <div class="row-2">
              <span>{{ datoContratante?.EMAIL }}</span>
            </div>
          </div>

          <div class="row telefono">
            <span>Teléfono Contacto</span>
            <div class="row-2">
              <span>+56 {{ datoContratante?.CELULAR }}</span>
            </div>
          </div>

          <div class="row region">
            <span>Región</span>
            <div class="row-2">
              <span
                [innerText]="
                  getNombreRegionByCodigo(datoContratante?.COD_REGION)
                "
              ></span>
            </div>
          </div>

          <div colspan="2" class="direccion">
            <div class="row">
              <span>Dirección Particular (calle, número, depto.)</span>
              <div class="row-2">
                <span>{{ datoContratante?.DIREC }}</span>
              </div>
            </div>
          </div>

          <div class="ciudad">
            <div class="row">
              <span>Ciudad</span>
              <div class="row-2">
                <span
                  [innerText]="
                    getNombreCuidadByCodigo(datoContratante?.COD_CIUDAD)
                  "
                ></span>
              </div>
            </div>
          </div>
          <div class="comuna">
            <div class="row">
              <span>Comuna</span>
              <div class="row-2">
                <span
                  [innerText]="
                    getNombreComunaByCodigo(datoContratante?.COD_MUNICIPIO)
                  "
                ></span>
              </div>
            </div>
          </div>

          <div class="divider">
            <mat-divider></mat-divider>
          </div>
          <div class="container-button">
            <button
              (click)="onEditMode()"
              mat-stroked-button
              class="button-detail"
            >
              Modificar
            </button>
            <button
              (click)="goToFirmar()"
              mat-flat-button
              class="btn-save button-detail"
            >
              Siguiente
            </button>
          </div>
        </div>

        <form [formGroup]="form" *ngSwitchCase="true">
          <div class="container-form">
            <div class="row custom-input-text form-telefono">
              <app-form-lablel
                [label]="'Teléfono particular'"
              ></app-form-lablel>
              <mat-form-field appearance="outline">
                <span matPrefix>+56 &nbsp;</span>
                <input
                  maxlength="9"
                  matInput
                  formControlName="Celular"
                  placeholder="Teléfono particular"
                  autocomplete="off"
                />
              </mat-form-field>
              <mat-error>{{ getErrorMessage(form, 'Celular') }}</mat-error>
            </div>
            <div class="row custom-input-text form-correo">
              <app-form-lablel [label]="'Correo electrónico'"></app-form-lablel>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  formControlName="Correo"
                  placeholder="Correo electrónico"
                  autocomplete="off"
                />
              </mat-form-field>
              <mat-error>{{ getErrorMessage(form, 'Correo') }}</mat-error>
            </div>
            <div class="row custom-input-text form-direccion">
              <app-form-lablel
                [label]="'Dirección particular'"
              ></app-form-lablel>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  formControlName="Direccion"
                  placeholder="Dirección particular"
                  autocomplete="off"
                />
              </mat-form-field>
              <mat-error>{{ getErrorMessage(form, 'Direccion') }}</mat-error>
            </div>
            <div class="row custom-input-text form-region">
              <app-form-lablel [label]="'Región'"></app-form-lablel>
              <mat-form-field appearance="outline">
                <mat-select
                  formControlName="CodigoRegion"
                  (selectionChange)="regionOnChange($event)"
                  placeholder="Región"
                >
                  <mat-option
                    *ngFor="let region of regiones"
                    [value]="region.CodigoRegion"
                  >
                    {{ region.Nombre }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-error
                >{{ getErrorMessage(form, 'CodigoRegion') }}
              </mat-error>
            </div>
            <div class="row custom-input-text form-ciudad">
              <app-form-lablel [label]="'Ciudad'"></app-form-lablel>
              <mat-form-field appearance="outline">
                <mat-select
                  (selectionChange)="ciudadOnChange($event)"
                  formControlName="CodigoCiudad"
                  placeholder="Ciudad"
                >
                  <mat-option
                    *ngFor="let ciudad of ciudades"
                    [value]="ciudad.CodigoCiudad"
                  >
                    {{ ciudad.Nombre }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-error
                >{{ getErrorMessage(form, 'CodigoCiudad') }}
              </mat-error>
            </div>
            <div class="row custom-input-text form-comuna">
              <app-form-lablel [label]="'Comuna'"></app-form-lablel>
              <mat-form-field appearance="outline">
                <mat-select formControlName="CodigoComuna" placeholder="Comuna">
                  <mat-option
                    *ngFor="let comuna of comunas"
                    [value]="comuna.CodigoComuna"
                  >
                    {{ comuna.Nombre }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-error
                >{{ getErrorMessage(form, 'CodigoComuna') }}
              </mat-error>
            </div>
            <div class="form-container-button">
              <div>
                <button
                  (click)="offEditMode()"
                  mat-stroked-button
                  class="button-detail"
                >
                  Cancelar
                </button>
              </div>
              <div class="btn-save">
                <button
                  [disabled]="!form.valid || !form.dirty"
                  (click)="save()"
                  mat-flat-button
                  class="button-detail"
                >
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card *ngIf="firmaVisible">
  <mat-card-header>
    <mat-card-title
      >FIRMA CONVENIO DE PRESTACIÓN DE SERVICIOS A DISTANCIA</mat-card-title
    >
  </mat-card-header>
  <mat-card-content>
    <div class="container">
      <p>
        Debes leer tu convenio y firmarlo antes de continuar.
      </p>

      <div class="pdf-container" *ngIf="!IE">
        <iframe
          width="100%"
          [src]="srcPDF"
          height="100%"
          z-index="1000"
          frameborder="0"
        >
          <object
            [data]="srcPDF"
            type="application/pdf"
            width="100%"
            height="100%"
          ></object>
        </iframe>
      </div>

      <div *ngIf="IE">
        <p>
          Puedes revisarlo aceptando la descarga automática, o pinchando en el
          siguiente botón:
        </p>
        <a [href]="srcPDF" [download]="srcPDF" target="_blank"></a>
        <div style="text-align: center;">
          <button
            class="button-class"
            mat-flat-button
            (click)="downloadPdfFirma()"
            [ngStyle]="{
              width:
                screenSize === 'sm' || screenSize === 'xs' ? '100%' : ' 108px'
            }"
          >
            Descarga PDF
          </button>
        </div>
      </div>

      <div class="check">
        <mat-checkbox #check [checked]="false"
          >Declaro conocer y aceptar</mat-checkbox
        >
      </div>

      <mat-divider></mat-divider>
      <div class="firmar-div" *ngIf="check.checked">
        <button (click)="firmar()" mat-flat-button class="align-right">
          Firmar
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="firmaDigitalState == 'invalid'">
  <mat-card-header class="mantencion-header">
    <mat-card-title class="mantencion-title"
      >SERVICIO EN MANTENCIÓN</mat-card-title
    >
  </mat-card-header>

  <mat-card-content>
    <div class="container">
      <p>
        Estimado cliente:
      </p>
      <p>
        Espera un momento, nuestro proveedor de Firma electrónica no está
        disponible. Por favor, vuelva a intentarlo más tarde. O si lo desea,
        también puede firmar personalmente el documento en una de nuestras
        sucursales.
      </p>

      <p>
        Si tiene alguna consulta, puede comunicarse con
        <strong>Servicio al Cliente</strong> llamando al
        <strong>800 222 100</strong> o a través de
        <a class="email" href="contactovida@security.cl"
          >contactovida@security.cl</a
        >
      </p>
    </div>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="firmaDigitalState == 'valid'">
  <mat-card-header>
    <mat-card-title>CONVENIO FIRMADO</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="container">
      <p>
        Estimado cliente:
      </p>
      <p>
        Estimado cliente: El proceso de firma digital del
        <strong>Convenio de Prestación de Servicios a Distancia</strong>, que le
        permitirá visualizar y realizar transacciones sobre sus pólizas, ha
        finalizado satisfactoriamente y en unos instantes será redirigido a la
        Página con sus <strong>Productos</strong> cargados.
      </p>
      <div class="center-block valid">
        <mat-icon>check_circle</mat-icon>
        <p>
          Validación completa.
        </p>
      </div>

      <div class="center-block">
        <button (click)="goToTraslado()" mat-flat-button class="align-right">
          Finalizar
        </button>
      </div>

      <p>
        Recibirá por e-mail una copia del documento firmado electrónicamente por
        usted.
      </p>
      <p>
        Si tiene alguna consulta, puede comunicarse con
        <strong>Servicio al Cliente</strong> llamando al
        <strong>800 222 100</strong> o a través de
        <a class="email" href="contactovida@security.cl"
          >contactovida@security.cl</a
        >
      </p>
    </div>
  </mat-card-content>
</mat-card>

<table
  id="mailTable"
  border="1"
  style="border-collapse: collapse;width:100%;visibility:hidden"
>
  <tbody>
    <tr>
      <td>
        CESARZ@LAGASH.COM
      </td>
    </tr>
    <tr>
      <td>
        CESARZ@LAGASH.COM
      </td>
    </tr>
  </tbody>
</table>
